import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./filter"

import http from './utils/request'
import AntD from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import animated from 'animate.css'

Vue.use(animated)

import Pagination from "./components/Pagination";

import {isAuth} from './utils/index'
Vue.prototype.isAuth = isAuth     // 权限方法

// 全局组件挂载
Vue.component('Pagination', Pagination)

Vue.config.productionTip = true;
Vue.prototype.$http = http;
Vue.use(AntD);
Vue.use(ElementUI);

import moment from 'moment';
Vue.prototype.$moment = moment;


Vue.prototype.$message = function(msg){
  ElementUI.Message(msg)
}
const messageArr = ['success', 'warning', 'info', 'error']

messageArr.forEach(function (type) {
  let configDet = {
    duration: 1200,
    offset:70
  }
  Vue.prototype.$message[type] = function (message) {
    return ElementUI.Message[type]({
      message,
      ...configDet
    });
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
